module.exports = __webpack_public_path__ + "img/assassination.5bccb633.jpg";